import React, { FC } from "react";
import NcImage from "shared/NcImage/NcImage";
import { Link } from "react-router-dom";

export interface CountryCardProps {
  className?: string;
  item: any;
}

const CountryCard: FC<CountryCardProps> = ({
  className = "",
  item,
}) => {
  return (

    <Link
      to={`/country-trips?code=${item[0].countryCode}&country=${item[0].name}`}
      className={`nc-CardCategory3 flex flex-col ${className}`}
      data-nc-id="CardCategory3"
    >
      <div
        className={`flex-1 aspect-h-16 aspect-w-10 relative rounded-2xl overflow-hidden group`}
      >
        <NcImage
          src={item[0].banner}
          className="object-cover w-full h-full rounded-2xl"
        />
        <span className="opacity-0 group-hover:opacity-100 absolute inset-0 bg-black bg-opacity-10 transition-opacity"></span>
      </div>

      <div className="mt-2 truncate flex-row">
        <span className="bg-primary-6000 text-xs md:text-sm z-10 rounded-lg  py-2 px-4 text-white bg-opacity-90 absolute -mt-16  ml-2  ">
          {item.numberOfGuide} Total Guide(s)
        </span>
        <h2
          className={`text-base sm:text-lg text-neutral-900 dark:text-neutral-100 font-medium truncate `}
        >
          {item[0].name}
        </h2>

      </div>
    </Link>
  );
};

export default CountryCard;
